import React from "react";
import "./FAQ.css";

function FAQ() {
  return (
    <div className="faq-container">
      <header className="faq-header">
        <div className="faq-header-content">
          <h1>Frequently Asked Questions</h1>
          <p className="last-updated">Last updated: January 28, 2025</p>
        </div>
      </header>

      <div className="faq-content">
        {/* Sidebar Navigation */}
        <aside className="faq-nav">
          <h3>Contents</h3>
          <ul>
            <li><a href="#how-leads-work">How do restaurant leads work?</a></li>
            <li><a href="#limits">What happens when I reach my limit?</a></li>
            <li><a href="#plans">Can I change plans later?</a></li>
            <li><a href="#ai-matching">What's included in AI Matching?</a></li>
            <li><a href="#refunds">Do you offer refunds?</a></li>
            <li><a href="#security">Is my data secure?</a></li>
            <li><a href="#ai-improvements">How does the AI find the right restaurants?</a></li>
            <li><a href="#data-accuracy">How accurate is the restaurant data?</a></li>
            <li><a href="#limits-daily">How many leads can I access per month?</a></li>
            <li><a href="#support">Need more help?</a></li>
          </ul>
        </aside>

        {/* Main FAQ Sections */}
        <main className="faq-main">
          <section id="how-leads-work">
            <h2>How do restaurant leads work?</h2>
            <p>
              Our AI scans and aggregates publicly available data on New York City restaurants,
              filters them based on your ideal customer profile, and delivers verified, actionable
              leads complete with contact details, cuisine type, neighborhood, and key business attributes.
            </p>
          </section>

          <section id="limits">
            <h2>What happens when I reach my limit?</h2>
            <p>
              You'll be notified when approaching your lead limit and can upgrade anytime.
              Your account and saved leads remain safe — you just can't access new leads until you upgrade or your limit resets.
            </p>
          </section>

          <section id="plans">
            <h2>Can I change plans later?</h2>
            <p>
              Absolutely! You can upgrade anytime with immediate effect.
              For downgrades, contact our support team and we'll help you transition smoothly.
            </p>
          </section>

          <section id="ai-matching">
            <h2>What's included in AI Matching?</h2>
            <p>
              AI Matching includes smart filtering by cuisine, neighborhood, restaurant size, and
              ownership type, lead scoring based on your sales criteria, competitor gap analysis,
              and real-time data enrichment — all powered by our proprietary AI algorithms built
              specifically for the New York restaurant market.
            </p>
          </section>

          <section id="refunds">
            <h2>Do you offer refunds?</h2>
            <p>
              Yes! We offer a 30-day money-back guarantee on all plans.
              If you're not satisfied, contact support for a full refund within 30 days of purchase.
            </p>
          </section>

          <section id="security">
            <h2>Is my data secure?</h2>
            <p>
              Your data security is our top priority.
              We use bank-level encryption, secure servers, and never share your information with third parties.
              All payments are processed securely through trusted providers.
            </p>
          </section>

          <section id="ai-improvements">
            <h2>How does the AI find the right restaurants?</h2>
            <p>
              Our AI continuously indexes NYC restaurant listings, health inspection records, social
              profiles, and business directories to build rich lead profiles. It then matches those
              profiles against your target criteria — delivering leads most likely to convert for
              your specific product or service.
            </p>
          </section>

          <section id="data-accuracy">
            <h2>How accurate is the restaurant data?</h2>
            <p>
              We verify and refresh our NYC restaurant database regularly to ensure contact details,
              addresses, and business status stay up to date. Each lead includes a confidence score
              so you always know the reliability of the information before you reach out.
            </p>
          </section>

          <section id="limits-daily">
            <h2>How many leads can I access per month?</h2>
            <p>
              That depends on your plan. Free users get 10 leads/month.
              Starter includes 100/month, Pro offers 500/month, and Premium is unlimited (with a fair-use cap of 50/hour).
            </p>
          </section>

          <section id="support">
            <h2>Need more help?</h2>
            <div className="contact-info">
              <p>Email: support@nyleads.ai</p>
              <p>We're here to help! Contact us for any additional questions.</p>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}

export default FAQ;